import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {AuthenticationService} from '../../_services/authentication.service';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";


@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

    model: any = {};
    loading = false;
    message: string;
    returnUrl: string;
    formLogin: FormGroup;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        formBuilder: FormBuilder,
        private authenticationService: AuthenticationService) {

        this.formLogin = formBuilder.group({
            email: new FormControl('', [Validators.required, Validators.email]),
            password: new FormControl('', [Validators.required, this.noAllSpaceValidator]),
        });
    }

    ngOnInit() {
        this.returnUrl = '/admin';
        this.checkLogin();
    }

    checkLogin() {
        var currentUser = this.authenticationService.getCurrentUser();
        if (currentUser != null) {
            currentUser.subscribe(data => {
                    this.router.navigate(["/admin"]);
                },
                error => {
                    // alert("Can't connect to server");
                    this.router.navigate(["/login"]);
                })
        }
    }

    login() {
        if (this.formLogin.valid) {
            this.loading = true;
            this.authenticationService.login(this.model.email, this.model.password)
                .subscribe(
                    data => {
                        this.router.navigate([this.returnUrl]);
                    },
                    error => {
                        if (error.json().error) {
                            this.message = error.json().error;
                        } else
                            this.message = "サーバーにアクセスできません。";
                        // this.alertService.error(error);
                        this.loading = false;
                    });
        }
    }

    logout() {
        this.authenticationService.logout();
        this.router.navigate(['/login']);
    }

    isFieldValid(field: string) {
        return !this.formLogin.get(field).valid && this.formLogin.get(field).touched;
    }

    displayFieldCss(field: string) {
        return {
            'has-error': this.isFieldValid(field),
            'has-feedback': this.isFieldValid(field)
        };
    }

    noAllSpaceValidator(control: FormControl) {
        return (((control.value || '').replace(/^\s+|\s+$/g, '').length == 0) ? {'whitespace': true} : null);
    }

    onKeyup(event) {
        this.message = "";
        this.loading = false;
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/login/login.component.ts